import './scss/standalone.scss';
// Import Toastify only in stand alone
import 'react-toastify/dist/ReactToastify.css';

import('./bootstrap');

export {};
